export const AmountFractionType = {
  COST: 'cost',
  QUANTITY: 'quantity',
} as const

export type AmountFractionType =
  (typeof AmountFractionType)[keyof typeof AmountFractionType]
